import React from 'react';
import PropTypes from 'prop-types';

import { Card, CardHeader } from 'material-ui/Card';
import { List } from 'material-ui/List';
import { FormattedPlural } from 'react-intl';
import { statusColours } from '../../constants/ColourConstants';

import PersonIcon from 'material-ui/svg-icons/social/person';
import AttendeeListItem from './AttendeeListItem';


const style = {
    list: {
        paddingTop: 0,
        paddingBottom: 0,
    },
};

const AttendeeSegment = ({guests}) => {

    const attending = guests.filter(({status}) => status === 'attending');

    if (!guests  || guests.length <= 0) { return false; } // guard

    return (
        <Card className="cent-card" key="guestListSegment">
            <CardHeader
                title="Attendees"
                subtitle={
                    <FormattedPlural
                        value={attending.length}
                        one='1 person attending'
                        other={`${attending.length} people attending`}
                    />
                }
                avatar={<PersonIcon color={statusColours.default}/>}
            />
            <List key="guestDetails" style={style.list}>
                {attending.map((guest) => (
                    <AttendeeListItem
                        key={guest.id}
                        data={guest}
                    />
                ))}
            </List>
        </Card>
    );

};

AttendeeSegment.propTypes = {
    guests:   PropTypes.arrayOf(PropTypes.object),
};

export default AttendeeSegment;
